import {
  BookOpenIcon,
  BriefcaseIcon,
  BuildingIcon,
  CalendarIcon,
  CarIcon,
  ClipboardCheckIcon,
  FileTextIcon,
  HandshakeIcon,
  KeyIcon,
  LaptopIcon,
  ListIcon,
  MonitorIcon,
  PackageIcon,
  PlaneIcon,
  ReceiptIcon,
  ShoppingCartIcon,
  TruckIcon,
  UsersIcon,
  WalletIcon,
  WrenchIcon,
  type LucideIcon,
} from 'lucide-react';

/** Icons a list may have (the backend's `ItemList.Icons`, same order). */
export const LIST_ICONS: Record<string, LucideIcon> = {
  list: ListIcon,
  'file-text': FileTextIcon,
  package: PackageIcon,
  'shopping-cart': ShoppingCartIcon,
  laptop: LaptopIcon,
  monitor: MonitorIcon,
  briefcase: BriefcaseIcon,
  plane: PlaneIcon,
  wallet: WalletIcon,
  receipt: ReceiptIcon,
  calendar: CalendarIcon,
  users: UsersIcon,
  building: BuildingIcon,
  truck: TruckIcon,
  wrench: WrenchIcon,
  'book-open': BookOpenIcon,
  'clipboard-check': ClipboardCheckIcon,
  handshake: HandshakeIcon,
  car: CarIcon,
  key: KeyIcon,
};

export const listIcon = (name: string | null | undefined): LucideIcon =>
  (name ? LIST_ICONS[name] : undefined) ?? ListIcon;

/** ₴ for hryvnias, the code for other currencies. */
export const currencySymbol = (code: string) => (code === 'UAH' ? '₴' : code);

/** Colors of enum options (chips readable in both themes). */
export const OPTION_COLORS = ['slate', 'sky', 'indigo', 'violet', 'emerald', 'amber', 'rose'] as const;

const CHIP: Record<string, string> = {
  slate: 'bg-slate-100 text-slate-700 dark:bg-slate-500/20 dark:text-slate-200',
  sky: 'bg-sky-100 text-sky-800 dark:bg-sky-500/15 dark:text-sky-300',
  indigo: 'bg-indigo-100 text-indigo-700 dark:bg-indigo-500/15 dark:text-indigo-300',
  violet: 'bg-violet-100 text-violet-700 dark:bg-violet-500/15 dark:text-violet-300',
  emerald: 'bg-emerald-100 text-emerald-800 dark:bg-emerald-500/15 dark:text-emerald-300',
  amber: 'bg-amber-100 text-amber-800 dark:bg-amber-500/15 dark:text-amber-300',
  rose: 'bg-rose-100 text-rose-700 dark:bg-rose-500/15 dark:text-rose-300',
};

const DOT: Record<string, string> = {
  slate: 'bg-slate-400',
  sky: 'bg-sky-500',
  indigo: 'bg-indigo-500',
  violet: 'bg-violet-500',
  emerald: 'bg-emerald-500',
  amber: 'bg-amber-500',
  rose: 'bg-rose-500',
};

/** Classes of an option chip (no color: the neutral secondary chip). */
export const optionChipClass = (color: string | null | undefined) =>
  (color ? CHIP[color] : undefined) ?? 'bg-secondary text-secondary-foreground';

export const optionDotClass = (color: string | null | undefined) =>
  (color ? DOT[color] : undefined) ?? 'bg-muted-foreground/40';
